import React from "react";
import { FileText, Search, CheckCircle, Shield } from "lucide-react";

export default function HowItWorks() {
  const steps = [
    {
      icon: FileText,
      title: "Case & Document Collection",
      description:
        "Upload your necessary documents and information securely through our platform. Our system ensures your data is protected throughout the process.",
    },
    {
      icon: Search,
      title: "Legal & Tax Review",
      description:
        "Our team of experienced professionals carefully reviews your submission to ensure accuracy and completeness before proceeding.",
    },
    {
      icon: CheckCircle,
      title: "Filing / Reply / Representation",
      description:
        "We handle all filing procedures and ensure full compliance with relevant regulations and requirements on your behalf.",
    },
    {
      icon: Shield,
      title: "Follow-up & Ongoing Support",
      description:
        "Receive confirmation of completion and enjoy continued support for any questions or future needs that may arise.",
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-16 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-lg text-gray-600">
            Handled under Advocate Supervision
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="relative">
                <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 h-full">
                  <div className="flex flex-col items-center text-center">
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center mb-4">
                      <Icon className="w-8 h-8 text-white" />
                    </div>
                    <div className="absolute -top-3 -left-3 w-10 h-10 bg-black rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg">
                      {index + 1}
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-3">
                      {step.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                    <div className="w-8 h-0.5 bg-indigo-300"></div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
